exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CheckboxList__container{font:normal 10px Verdana;white-space:nowrap}.CheckboxList__label{font-size:11px;font-weight:700;margin-bottom:7px}.CheckboxList__checkbox{cursor:pointer}.CheckboxList__item{cursor:pointer;display:block;margin-bottom:3px}.CheckboxList__itemText{margin-left:3px;position:relative;top:-2px;vertical-align:middle}", ""]);

// exports
exports.locals = {
	"container": "CheckboxList__container",
	"label": "CheckboxList__label",
	"checkbox": "CheckboxList__checkbox",
	"item": "CheckboxList__item",
	"itemText": "CheckboxList__itemText"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":true,"localIdentName":"[name]__[local]"}!./client/components/CheckboxList.css
// module id = 25
// module chunks = 0